import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CountdownTimer.css';

interface CountdownTimerProps {
  targetDate: Date;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = targetDate.getTime();
      const difference = target - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
      }
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const formatNumber = (num: number): string => {
    return num.toString().padStart(2, '0');
  };

  return (
    <div className="countdown-timer">
      <div className="countdown-box">
        <span className="countdown-number">{formatNumber(timeLeft.days)}</span>
        <span className="countdown-label">{t('home.upcomingEvents.countdown.days')}</span>
      </div>
      <div className="countdown-box">
        <span className="countdown-number">{formatNumber(timeLeft.hours)}</span>
        <span className="countdown-label">{t('home.upcomingEvents.countdown.hours')}</span>
      </div>
      <div className="countdown-box">
        <span className="countdown-number">{formatNumber(timeLeft.minutes)}</span>
        <span className="countdown-label">{t('home.upcomingEvents.countdown.minutes')}</span>
      </div>
      <div className="countdown-box">
        <span className="countdown-number">{formatNumber(timeLeft.seconds)}</span>
        <span className="countdown-label">{t('home.upcomingEvents.countdown.seconds')}</span>
      </div>
    </div>
  );
};

export default CountdownTimer;









